import './Manual.scss';
import React from 'react';
import { Link, Element } from 'react-scroll';
import login from './screenshots/login.png';
import telasInfo from './screenshots/telas-info.png';
import menu from './screenshots/menu.png';
import botaoDigitalizar from './screenshots/botao-digitalizar.png';
import confirmarLimpar from './screenshots/confirmar-limpar.png';
import telaDigitalizacao from './screenshots/tela-digitalizacao.png';
import deletarCupom from './screenshots/deletar-cupom.png';
import status from './screenshots/status.png';
import correcoes1 from './screenshots/correcoes-1.png';
import correcoes2 from './screenshots/correcoes-2.png';
import correcoes3 from './screenshots/correcoes-3.png';
import correcoes4 from './screenshots/correcoes-4.png';
import buscar from './screenshots/buscar.png';
import finalizando from './screenshots/finalizando.png';

function Manual() {
    return (
        <div id="manual-control-docs">
            <h1>Control Docs</h1>
            <h2>Manual de utilização do sistema</h2>

            <ul id="menu">
                <li><Link to="acesso" spy={true} hashSpy={true} smooth={true} offset={-15} duration={1000}>Acesso</Link></li>
                <li><Link to="info-tela" spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Informações na Tela</Link></li>
                <li><Link to="nav" spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Navegação</Link></li>
                <li>
                    <Link to="passo-a-passo" spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Passo a passo</Link>
                    <ul>
                        <li><Link to="digi-cupom-anexo" spy={true} hashSpy={true} offset={-20} smooth={true} duration={1000}>Digitalizando cupons e anexos</Link></li>
                        <li><Link to="conferencia-confirmacao" spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Conferência / Confirmação</Link></li>
                        <li><Link to="ident-prob" spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Identificando problemas</Link></li>
                        <li><Link to="solucionando-prob" spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Solucionando problemas</Link></li>
                    </ul>
                </li>
                <li>
                    <span>Galeria / <s>Workspace</s></span>
                    <ul>
                        <li><Link to='pesquisar' spy={true} hashSpy={true} smooth={true} offset={-20} duration={1000}>Pesquisar</Link></li>
                    </ul>
                </li>
            </ul>

            <Element name='acesso' className="topic">
                <h3>Acesso</h3>
                <p>Para acessar o sistema selecione a sua unidade e informe seu usuário/senha utilizados no DPNet. Letras maiúsculas e minúsculas importam.</p>
                <img src={login} alt="login" />
            </Element>

            <Element name='info-tela' className="topic">
                <h3>Informações na tela</h3>
                <p>Após acessar o sistema a primeira tela a ser carregada é a de digitalização. As telas possuem informações instrutivas. Vide abaixo.</p>
                <img src={telasInfo} alt="Informações na tela" />
                <dl>
                    <dt>Unidade/Usuário</dt>
                    <dd>Exibe a unidade/usuário que está logado no sistema.</dd>

                    <dt>Conexão de internet</dt>
                    <dd>Exibe o status de conexão com a internet, podendo ser "Conetado", "Sem internet" ou "Bloqueio".</dd>

                    <dt>Versão do software</dt>
                    <dd>Versão do software que está instalada no computador.</dd>
                </dl>
            </Element>

            <Element name='nav' className="topic">
                <h3>Navegação</h3>
                <img src={menu} alt="Menu" />
                <ul>
                    <li>
                        <span>Aplicação</span>
                        <ul>
                            <li>
                                <span>Sair</span>
                                - Realiza a saída segura do sistema (logout).
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span>Ir</span>
                        <ul>
                            <li>
                                <span>Digitalizar</span>
                                - Tela onde os cupons são scanneados.
                            </li>
                            <li>
                                <span>Galeria</span>
                                - Tela de gerenciamento dos lançamentos.
                            </li>
                        </ul>
                    </li>
                </ul>
            </Element>

            <Element name='passo-a-passo'>
                <h3>Passo a passo</h3>
                <p>Realizando lançamentos de cupons</p>

                <Element name='digi-cupom-anexo' className="topic">
                    <h4>Passo 1: Digitalizando cupons e anexos</h4>
                    <p>Após acessar o sistema, vá até a tela de digitalização.</p>
                    <p>Posicione os cupons no scanner de modo que fiquem corretamente alinhados. Para melhor desempenho, os scanners possuem uma aleta para regular o tamanho do papel. Caso aja necessidade você pode ajustar a mesma deixando uma folga nas laterais para que o cupom deslize corretamente. Em alguns casos a melhor opção é não ajustar as aletas, faça o teste você mesmo(a).</p>
                    <p>Após posicionar os cupons pressione o botão "Digitalizar" localizado na parte superior direta da tela.</p>
                    <div className="attention">
                        É obrigatório organizar os documentos na seguinte sequência: Cupons, segunda-via de cupons (caso existente) e autorizações.
                        É a mesma ordem utilizada no sistema DocSystem.
                        Seguindo esta ordem você pode colocar múltiplos lançamentos de cupons, todos juntos.
                    </div>
                    <img src={botaoDigitalizar} alt="Botão digitalizar"/>
                </Element>

                <Element name='conferencia-confirmacao'>
                    <h4>Passo 2: Conferência / Confirmação</h4>
                    <p>Todos os documentos digitalizados aparecem como miniatura na esquerda da tela. Você pode utilizar o scroll do mouse e navegar entre os cupons. Para visualizar em tamanho maior, basta clicar 1x.</p>
                    <div className="attention">É importante conferir se os cupons/autorizações foram devidamente digitalizados.</div>
                    <img src={telaDigitalizacao} alt="Tela de digitalização"/>
                    <p>Caso deseje excluir algum documento, basta clicar com o botão direito do mouse em cima da miniatura do mesmo e depois em Deletar.</p>
                    <img src={deletarCupom} alt="Deletar Cupom"/>
                    <p>Para cancelar todo o processo e limpar as digitalizações por completo, basta clicar no botão "Limpar documentos" no canto superior direito.</p>
                    <div className="attention">Caso não saiba o nome do botão, basta passar o mouse sobre o mesmo.</div>
                    <img src={confirmarLimpar} alt="Confirmar / Limpar" />
                    <p>Clique no botão "Confirmar" para continuar o lançamento e depois em "Prosseguir".</p>
                </Element>

                <Element name='ident-prob'>
                    <h4 style={{ marginTop: 20 }}>Passo 3: Identificando problemas</h4>
                    <p>Aguarde o sistema finalizar o upload dos documentos.</p>
                    <img src={status} alt="Status" />
                    <p>Observe o resumo em vermelho na parte inferior da tela. Em um total de 47 cupons emitidos no AutoSystem, o sistema fez uma contagem de 42, ou seja, algo está errado.</p>
                    <p>Para verificarmos com mais facilidade, organize os cupons por Quantidade de documentos (coluna Qtd. Doc) na tabela.</p>
                    <img src={correcoes1} alt="Correções" />
                    <div className="attention">
                        <p>Clicando no primeiro processo e olhando na parte esquerda da tela, nas miniaturas, existem vários cupons agrupados. Isso acontece quando o sistema não consegue identificar o código de barras, assim, tratando o cupom como anexo adicional. Nesse exemplo, cobrimos com preto alguns códigos de barras, somente para exemplificar.</p>
                        <p>Você deve conferir a quantidade de documentos em cada cupom, caso suspeite que aquele cupom esteja com muitos documentos, clique no lançamento (tabela) e faça uma verificação nas miniaturas. Você pode clicar 2x para expandir um documento.</p>
                        <p>Esse processo é de <span style={{ color: '#000' }}>EXTREMA IMPORTÂNCIA</span>, cupons agrupados incorretamente geram problemas para os clientes finais da Rede Dom Pedro, que baixam documentos em nosso site.</p>
                    </div>
                </Element>

                <Element name='solucionando-prob'>
                    <h4>Passo 4: Solucionando problemas (Desagrupando e vinculando cupons)</h4>
                    <p>Selecione o cupom que não pertence ao grupo, clique com o botão direto do mouse e escolha a opção "Criar novo grupo". A seleção do cupom é obrigatória. Você pode selecionar múltiplos cupons/anexos.</p>
                    <img src={correcoes2} alt="Correções" />
                    <p>O cupom foi movido para um novo lançamento na tabela a direita e agora apresenta um status diferente. "ID necessário".</p>
                    <img src={correcoes3} alt="Correções" />
                    <p>Na tabela, clique no lançamento com status "ID Necessário" e na esquerda clique 2x na miniatura do cupom para expandir o cupom, semelhante a tela abaixo.</p>
                    <p>Insira o código do cupom no campo código de barras e clique no botão "Adicionar".</p>
                    <p>Se tudo ocorrer bem você realizou a vinculação de um cupom em que o código de barras não foi identificado pelo sistema.</p>
                    <p>Clique na área escura fora do cupom para fechar a janela e repare que o status do cupom mudou para "Pronto".</p>
                    <img src={correcoes4} alt="Correções" />
                </Element>

                    <h4>Conferência final</h4>
                    <p>Após realizar todos os procedimento necessários, o mais importante é saber se os lançamentos do dia estão prontos. Então na área de resumo, verifique se os textos estão verdes e se as quantidades se igualam aos totais.</p>
                    <img src={finalizando} alt="Finalizando"/>
            </Element>

            <Element name='pesquisar' className="topic">
                <h3>Pesquisar</h3>
                <p>Encontrar cupons</p>
                <img src={buscar} alt="Buscar" />
                <dl>
                    <dt>Data de lançamento</dt>
                    <dd>Data em que foi realizado o scan do cupom no Control Docs.</dd>

                    <dt>Data de Emissão</dt>
                    <dd>Data em que foi realizada a venda para o cupom.</dd>

                    <dt>ID AS / Código de barras</dt>
                    <dd>Código de barras do cupom / ID do AutoSystem.</dd>
                </dl>
            </Element>

            {/* <Element name='perguntas-frequentes'>
                <h3>Perguntas Frequentes</h3>
                <dl>
                    <dt></dt>
                    <dd></dd>
                </dl>
            </Element> */}
        </div>
    );
}
export default Manual;
